// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19U1B","comment":"styles_comment__1PTk8"};